export default [
  // 直播间页面
  {
    path: '/BloomLive',
    name: 'BloomLive',
    meta: {
      IndexHeader: true,
      itemIndex: -1
    },
    component: () =>
    import(/* webpackChunkName: "BloomLive" */ '@/components/bloom-live/index')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/bloom-live.js